<div class="swiper-container" draggable="true" #swiperBottom (dragstart)="saveFistPositionDrag($event)"
    (touchstart)="saveFistPositionTouch($event)" (dragsend)="dragOver($event)" (touchend)="touchOver($event)"
    [ngClass]="{'retracted' : !full}" (click)="onClick()">
    <div class="content-swiper">
        <ng-content></ng-content>
    </div>
</div>